import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function saveGrant(grant) {
    return mutate(
        gql`
            mutation saveGrant($grant: JSONObject!) {
                saveGrant(grant: $grant)
            }
        `,
        { grant },
        { returns: "saveGrant" }
    )
}

export async function removeGrant(id) {
    return mutate(
        gql`
            mutation removeGrant($id: String!) {
                removeGrant(id: $id)
            }
        `,
        { id },
        { returns: "removeGrant" }
    )
}
